export default __webpack_public_path__ + "static/media/NotFound.f0d28759.png";